import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { isEmpty, result, size } from "lodash"
import * as moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import classNames from "classnames"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import ReactDrawer from 'react-drawer';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import RightDrawer from "../../components/Common/RightDrawer"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import SalesEntryListDetails from "pages/Sales/SalesEntryListDetails"
import { getSalesEntryList } from "helpers/backend_helper"
import { deleteItemDirect as onDeleteItemDirect } from "helpers/backend_helper"
import Loader from "components/Common/Loader"
import SalesListFilter from "../../components/Common/SalesListFilter"

const SalesEntryList = props => {
  const dispatch = useDispatch()
  const {
    match: { params },
  } = props

  useEffect(() => {
    if (params && params.id) {
      setSelectedSalesId(params.id)
      getSalesLists(params.id)
    }
    else{
      getSalesLists('')
    }
  }, [])

  async function getSalesLists(salesid){
    setShowLoading(true)
    getSalesEntryList().then(result => {
      setSalesEntryList(result)
      if(salesid && salesid != ''){
        const selectedRowTemp = result.filter(each => each.id == salesid)
        if(selectedRowTemp && selectedRowTemp.length == 1){
          setSelectedRow(selectedRowTemp[0])
          setShowReceipt(true)
        }
      }
      setShowLoading(false)
    })
  }

  const [salesEntryList, setSalesEntryList] = useState([])
  const [selectedRow, setSelectedRow] = useState()

  const [searchInProgress, setSearchInProgress] = useState(false)

  const [isEdit, setIsEdit] = useState(false)

  
  const [selectedSalesId, setSelectedSalesId] = useState()
  const [newItemToAdd, setNewItemToAdd] = useState()
  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)
  const [detailsForEdit, setDetailsForEdit] = useState()
  const [showDeletePopUp, setShowDeletePopUp] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [deleteMessage, setDeleteMessage] = useState('')
  const [itemToDelete, setItemToDelete] = useState()
  const [showLoading, setShowLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  
  const [showReceipt, setShowReceipt] = useState(false)

  function addNewItem(item) {
    setPosition('right')
    setOpen(!open)
    setNewItemToAdd(item)
  }
  const onDrawerClose = () => {
    setOpen(false);
  }
  const onNewlyAddedValue = (value) => {
  }
  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: size(salesEntryList), 
    custom: true,
    onPageChange: (page, sizePerPage) => {
      setCurrentPage(page)
    }
  }
  const { SearchBar } = Search

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const SalesEntryListColumns = () => [
    {
      dataField: "invoiceno",
      text: "Inv #",
      sort: true,
      sortValue: (cell, row) => Number(cell),
    },
    {
      dataField: "invoicedate",
      text: "Invoice Date",
      sort: true,
      formatter: (cellContent, row) => handleValidDate(cellContent),
      filterValue: (cellContent, row) => handleValidDate(cellContent),
    },
    {
      dataField: "customerdetails",
      text: "Customer Details",
      sort: true,
    },
    {
      dataField: "grandtotal",
      text: "Amount",
      sort: true,
      formatter: (cellContent, row) => (Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 2})),
      
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) => (
        <Badge className={cellContent== "PAID"? "font-size-12 bg-success badge-success":"font-size-12 bg-warning badge-warning"}>
          {cellContent}
        </Badge>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, item) => (
        <>

        {<UncontrolledDropdown>
          <DropdownToggle
            href="#"
            className="card-drop"
            tag="i"
            onClick={(e) => {e.stopPropagation()}}
          >
            <i className="mdi mdi-dots-horizontal font-size-18" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
              tag={Link} 
              to={"/edit-salesentry/"+item.id}
              onClick={(e) => {e.stopPropagation()}}
            >
              <i className="mdi mdi-pencil font-size-16 text-success me-1" />{" "}
              Edit
            </DropdownItem>
            <DropdownItem
              tag={Link} 
              to={"/add-sales-payment/"+item.customerid}
              onClick={(e) => {e.stopPropagation()}}
            >
              <i className="bx bx-dollar font-size-16 text-primary me-1" />{" "}
              Add Payment
            </DropdownItem>
            {/*<DropdownItem
              tag={Link} 
              to={"/sales-return/"+item.id}
              onClick={(e) => {e.stopPropagation()}}
            >
              <i className="bx bx-reset font-size-16 text-danger me-1" />{" "}
              Add Sales Return
            </DropdownItem>*/}
          </DropdownMenu>
        </UncontrolledDropdown>
        }
        </>
      ),
    },
  ]

  const handleEditClick = arg =>{
    setDetailsForEdit(arg)
    setIsEdit(true)
    addNewItem('Supplier')
  }

  const handleDeleteClick = arg => {
    setItemToDelete(arg)
    setDeleteMessage(arg.label)
    setShowDeletePopUp(true)
  }

  const confirmDelete = async () =>{
    setShowDeletePopUp(false)
    setShowLoading(true)
    const response =  await onDeleteItemDirect({
      'key': itemToDelete.value,
      'value' : 'SalesEntry'
    }, '')
    setShowLoading(false)
    if(response.status == 'success'){
      showSuccessToast('Deleted Successfully!!!')
    }
    else if(response.status == 'failure'){
      setErrorMessage(response.errorResponse)
      setShowErrorPopUp(true)
    }
  }

  const selectRow = {
    mode: 'radio',
    hideSelectColumn: true,
    clickToSelect: true,
    bgColor: '#e8e2d7',
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelectedRow(row)
      setShowReceipt(true)
    }
  };

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  function hideReceipt(){
    setShowReceipt(false)
  }

  const [filterApplied, setFilterApplied] = useState(false)
  const [searchCriteria, setSearchCriteria] = useState({})
  const [searchDispCriteria, setSearchDispCriteria] = useState({
    customername: 'All',
    status : 'Any'
  })

  function onSearch(searchCritiria){
    setSearchCriteria(searchCritiria)
    setSearchInProgress(true)
    getSalesEntryList(searchCritiria).then(result => {
      if(!result.errorCode){
        setSalesEntryList(result)
      }
      setSearchInProgress(false)
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>View All Sales Entry | Flamingo</title>
        </MetaTags>
        {!showReceipt && <Container fluid>
          <Breadcrumbs title="Sales" breadcrumbItem="View All Sales Entries" />
          <Loader showLoader={showLoading} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="invoiceno"
                    columns={SalesEntryListColumns()}
                    data={salesEntryList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="invoiceno"
                        data={salesEntryList}
                        columns={SalesEntryListColumns()}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="6">
                              <div className={classNames({"d-none": currentPage !== 1},"search-box me-2 mb-2 d-inline-block")}>
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="6">
                                <Row>
                                  <Col lg="4" className="d-flex align-items-center">
                                    <div className="text-sm-end">
                                      <Link
                                        to="/add-sales"
                                        role="button"
                                        className="btn btn-success btn-rounded  mb-2 me-2"
                                      >
                                        <i className="mdi mdi-plus me-1" />
                                        Add New Sales Entry
                                      </Link>
                                    </div>
                                  </Col>
                                  <Col lg="8" className="">
                                    <SalesListFilter 
                                    filterApplied={filterApplied}
                                    setFilterApplied={setFilterApplied}
                                    searchCriteria={searchCriteria}
                                    searchDispCriteria={searchDispCriteria}
                                    setSearchDispCriteria={setSearchDispCriteria}
                                    onSearch={onSearch} 
                                    searchInProgress={searchInProgress}/>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive min-height-200">
                                  <BootstrapTable
                                    keyField="invoiceno"
                                    responsive
                                    selectRow={selectRow}
                                    bordered={false}
                                    striped={false}
                                    //defaultSorted={defaultSorted}
                                    classes={
                                      "table align-middle table-hover pointer-cursor"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    noDataIndication={<div className="text-center">- No results found -</div>}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>}

        {showReceipt && <SalesEntryListDetails 
        salesEntryList={salesEntryList} 
        selectedRow={selectedRow} 
        filterApplied={filterApplied}
        searchCriteria={searchCriteria}
        searchDispCriteria={searchDispCriteria}
        hideReceipt={hideReceipt}/>
        }

      </div>
      <ReactDrawer
        open={open}
        position={position}
        onClose={onDrawerClose}
      >
        <RightDrawer 
          onClose={onDrawerClose} 
          currentItem={newItemToAdd} 
          onNewlyAddedValue={onNewlyAddedValue}
          selectedId={null}
          detailsForEdit={detailsForEdit}
          isEdit={isEdit}
        />
      </ReactDrawer>
      {showDeletePopUp ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete()
          }}
          onCancel={() => {
            setShowDeletePopUp(false)
          }}
        >
          <p>Deleting Supplier : <b>{deleteMessage}</b></p>
          You won't be able to revert this!
        </SweetAlert>
      ) : null}
      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

SalesEntryList.propTypes = {
  salesEntryList: PropTypes.array,
}

export default withRouter(SalesEntryList)
